export default "__VITE_ASSET__Ifmc_tot__"